import React from 'react';
import styled from 'styled-components';
import { HeadingText } from '../common';
import Cards from '../../howToWriteResume/cards';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const ContentWrap = styled.section`
  grid-column: 1/ 13;
`;

const Wrapper = styled.section`
  padding-top: 40px;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  @media ${breakpointsMinWidth.tabletMd} {
    padding-top: 50px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding-top: 55px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding-top: 65px;
  }
`;

const CardsSection = () => {
  return (
    <Wrapper>
      <ContentWrap>
        <HeadingText>Our Services are Beyond Features</HeadingText>
        <Cards higherEd />
      </ContentWrap>
    </Wrapper>
  );
};

export default CardsSection;
